export default __webpack_public_path__ + "static/media/stake-more-bnb-om.639280e6.svg";